import React, { useState } from 'react';
import { Input, Chip } from '@material-ui/core';
import { PlayArrow } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { asyncFetch, sortByDate } from '../../helperFunctions';
import { setData, setTaskStarted, setSnackbar } from '../redux';

export default () => {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState('');
  const isAdmin = useSelector(state => state.auth.isAdmin);
  const data = useSelector(state => state.tasks.data);
  const [testDataLoaded, setTestDataLoaded] = useState(true);

  return (
    (isAdmin || process.env.REACT_APP_ENV !== 'Prod') && (
      <>
        <Input
          style={{ marginBottom: '0px' }}
          size="small"
          margin="none"
          onChange={y => setUserName(y.target.value)}
        />
        {testDataLoaded && data.loaded && (
          <Chip
            avatar={<PlayArrow />}
            onClick={() => {
              setTestDataLoaded(false);
              (async () => {
                const response = await asyncFetch(
                  `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/get-app-data?username=${ userName|| process
                    .env.REACT_APP_DEFAULT_TECHNICIAN }`,
                  undefined,
                  undefined,
                  undefined,
                  dispatch
                );

                if (response) {
                  if (Object.keys(response).includes('tasks') && response.tasks.length > 0) {
                    const sortedTasks = response.tasks.sort((a, b) => sortByDate(a, b));
                    dispatch(
                      setData({
                        ...response,
                        tasks: sortedTasks,
                        loaded: true,
                        processedOldDevices: [],
                      })
                    );
                    const startedTasks = response.tasks.filter(x => x.appStart && !x.appEnd);
                    startedTasks.length > 0
                      ? dispatch(setTaskStarted({ started: true, taskId: startedTasks[0].id }))
                      : dispatch(setTaskStarted({ started: false, taskId: null }));
                    setTestDataLoaded(true);
                  } else if (
                    Object.keys(response).includes('tasks') &&
                    response.tasks.length === 0
                  ) {
                    setTestDataLoaded(true);
                    dispatch(
                      setSnackbar({
                        open: true,
                        message: 'Няма задачи за деня',
                      })
                    );
                  } else {
                    dispatch(
                      setSnackbar({
                        open: true,
                        message: 'Възникна системна грешка',
                      })
                    );
                  }
                }
              })();
            }}
            clickable
          />
        )}
      </>
    )
  );
};
